<template>
  <div>
    Ini adalah halaman 2

    <button @click="pindah">Klik this button, to navigation</button>

    <!-- Button trigger modal -->
    <button
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#exampleModal"
    >
      Launch demo modal
    </button>

    <!-- <qrcode-reader @decode="onDecode"></qrcode-reader> -->

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            {{ dataOtp }}
            <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">...</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "halaman-2",
  components: {},
  data() {
    return {
      dataAPI: {},
    };
  },
  computed: {
    ...mapState("playground", {
      dataOtp: "dataOtp",
    }),
  },
  methods: {
    // onDecode(decodedString) {
    //   console.log(decodedString);
    // },
    ...mapActions({
      postSendOtp: "playground/postSendOtp",
    }),
    pindah() {
      let data = {
        telp: "85159722546",
        country_code: "62",
      };
      this.postSendOtp(data);
    },
  },
};
</script>
